import React from 'react';
import { motion } from 'framer-motion';

const IosCard = ({ children, title, icon, color = "blue", className = "" }) => {
    // 🎨 خريطة الألوان بستايل iOS (توهج الأيقونة والظل الخلفي)
    const colorMap = {
        blue: "bg-[#007AFF] shadow-[#007AFF]/30",
        emerald: "bg-[#34C759] shadow-[#34C759]/30",
        orange: "bg-[#FF9500] shadow-[#FF9500]/30",
        purple: "bg-[#AF52DE] shadow-[#AF52DE]/30",
        pink: "bg-[#FF2D55] shadow-[#FF2D55]/30",
        cyan: "bg-[#32ADE6] shadow-[#32ADE6]/30"
    };

    return (
        <motion.div 
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            whileHover={{ y: -8, scale: 1.01 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            // 🛠️ تم استخدام ios-glass لضمان الشفافية العميقة والـ Saturate العالي
            className={`ios-glass p-8 relative overflow-hidden flex flex-col group ${className}`}
            style={{ 
                borderRadius: '35px',
                border: '1px solid rgba(255, 255, 255, 0.4)'
            }}
        >
            {/* ✨ تأثير الـ Reflection (انعكاس ضوئي علوي) */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/20 to-transparent pointer-events-none z-0"></div>

            {/* 🍏 الهيدر: الأيقونة مع تأثير التوهج (Glow) */}
            {title && (
                <div className="flex items-center gap-5 mb-8 relative z-10">
                    {icon && (
                        <div className={`p-4 rounded-[22px] text-white shadow-2xl ${colorMap[color]} transition-all duration-500 group-hover:scale-110 group-hover:rotate-3 flex items-center justify-center icon-container`}>
                            {icon}
                        </div>
                    )}
                    <h3 className="text-xl font-black text-gray-800 tracking-tight leading-tight">
                        {title}
                    </h3>
                </div>
            )}

            {/* 📱 المحتوى: بخط واضح وتنسيق مريح للعين */}
            <div className="custom-scroll overflow-y-auto max-h-[550px] pr-3 relative z-10 text-gray-700 font-bold leading-relaxed">
                {children}
            </div>

            {/* 🌈 لمسة جمالية: ظل ضوئي ملون عميق (Deep Light Leak) */}
            <div className={`absolute -bottom-12 -left-12 w-48 h-48 rounded-full opacity-20 blur-[60px] ${colorMap[color].split(' ')[0]}`}></div>
            <div className={`absolute -top-12 -right-12 w-32 h-32 rounded-full opacity-10 blur-[40px] ${colorMap[color].split(' ')[0]}`}></div>
        </motion.div>
    );
};

export default IosCard;